import React, {useEffect, useRef, useState} from "react";
import {useHistory, withRouter} from "react-router-dom";
import QnectTextField from "../qnect-ui/qnect-text-field";
import VerificationCodeDialog from "../custom/login/verification-code-dialog";
import TooManyFailedAttemptsDialog from "../custom/login/too-many-failed-attempts-dialog";
import {ReactComponent as Logo} from "../../assets/login/icon_logo.svg";

import {
    _clearToken,
    _generatePortfolioToken, _getLang,
    _getShowOtpModal,
    _hideModal,
    _hideSpinner,
    _isNoLogin,
    _setCpToken,
    _setLang,
    _setOtpToken,
    _setPortfolioToken,
    _setShowOtpModal, _setTimerStarted,
    _showModal,
    _showSpinner,
    _verifyOtpAndGetUserDetail,
    _getSystemAvailable,
    _getIsPvtModeOn,
    _getScheduledMaintenance
} from "../../store/system/service";

import {connect} from "react-redux";
import {_getPolicy, _resetPolicy, _storePolicy} from "../../store/policy/service";
import useConfig from "../qnect-ui/qnect-config";
import useLoginStyles, {StyledModalDiv} from "./login-style";
import {_validateForm, customReplaceAll} from "../../utils/utility";

import QnectButton from "../qnect-ui/qnect-button";
import FieldWrapper from "../custom/field-wrapper";
import Hidden from "@material-ui/core/Hidden";

import TopNotice from '../custom/top-notice';
import {
    _checkEmailIfRegistered,
    _getUser,
    _getUserDetailsFromToken,
    _resetUser,
    _sendResetPasswordLink,
    _storeUser,
    _verifyUserCredentials
} from "../../store/user/service";
import ForgotPasswordDialog from "../custom/login/forgot-password-dialog";
import TagManager from "react-gtm-module";
import BalloonTip from "../ui/balloon-tip/balloon-tip";
import ScheduledMaintenanceBanner from "../custom/scheduled-maintenance-banner";
import SystemUnavailableBanner from "../custom/system-unavailable-banner";

const Login = (props) => {
    const history = useHistory();
    const cfg = useConfig(props.lang);
    const formId = 'login-form';
    const classes = useLoginStyles(props);
    const ref = useRef(null);

    const [emailAddress, setEmailAddress] = useState("");
    const [maskedEmail, setMaskedEmail] = useState("");
    const [otpValue, setOtpValue] = useState("");
    const [emailErrorMessage, setEmailErrorMessage] = useState("");
    const [otpErrorMessage, setOtpErrorMessage] = useState("");
    const [resendTimer, setResendTimer] = useState(0);
    const [resendTimerIntervalId, setResendTimerIntervalId] = useState(null);
    const [sendEmailToSMSError, setSendEmailToSMSError] = useState('');

    const [verifyOpen, setVerifyOpen] = useState(false);
    const [reconfirmOpen, setReconfirmOpen] = useState(false);
    const [forgetOpen, setForgetOpen] = useState(false);
    const [contactOpen, setContactOpen] = useState(false);
    const [policyOpen, setPolicyOpen] = useState(false);
    const [failedOpen, setFailedOpen] = useState(false);

    const [password, setPassword] = useState();
    const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

    const [openForgotPasswordDialog, setOpenForgotPasswordDialog] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const [forgotPasswordErrorMessage, setForgotPasswordErrorMessage] = useState("");

    useEffect(() => {
        props.clearToken();
        props.resetPolicy();
        props.resetUser();

        TagManager.dataLayer({
            dataLayer: {
                event: 'vpageview',
                pageStep: 'login',
                vPath: '/login'
            }
        });
    }, []);

    const resetResendTimer = () => {
        if (resendTimerIntervalId) {
            clearInterval(resendTimerIntervalId);
        }
        // email timer
        setResendTimer(600);
        let setTimerInterval = setInterval(() => {
            setResendTimer((prevTimer) => {
                if (prevTimer > 0) {
                    return prevTimer - 1;
                } else {
                    clearInterval(setTimerInterval);
                    return 0;
                }
            });
        }, 1000);
        setResendTimerIntervalId(setTimerInterval);
    }

    function handleLogin() {
        if (_validateForm(formId)) {
            props.showSpinner();
            setOtpValue("");
            setOtpErrorMessage('');
            setEmailErrorMessage("");
            setPasswordErrorMessage('');
            props.verifyUserCredentials(emailAddress, password).then((response) => {
                if (response.success) {
                    if (!response.lockType) {
                        if (response.isExisting === 'true') {

                            props.user.email = emailAddress;
                            props.storeUser(props.user);
                            props.setCpToken(response.token);

                            let val = emailAddress.split('@')[0];
                            let regexToUse = val.length > 4 ? /^.*(?=....@)/g : /^.*(?=@)/g;
                            let emailMasked = customReplaceAll(regexToUse, emailAddress, '•');
                            setMaskedEmail(emailMasked);

                            resetResendTimer();
                            setVerifyOpen(true);

                            TagManager.dataLayer({
                                dataLayer: {
                                    event: 'popup',
                                    popupPath: '/login',
                                    popupTitle: 'Please Enter the Verification Code Received'
                                }
                            });

                        } else {
                            setEmailErrorMessage(cfg("loginEmailAddress.errorMessages.emailNotFound"));
                            setPasswordErrorMessage(cfg("loginPassword.errorMessages.passwordWrong"));
                        }
                        props.hideSpinner();
                    } else {
                        props.showModal({
                            flat: true,
                            content: <StyledModalDiv>
                                <div className="iconDiv">
                                </div>
                                <div className="title">Email Address is Locked</div>
                                <div className="content">Please try again
                                    after {response.lockType === 'otp' ? '10 minutes' : '1 hour'}</div>
                                <div className="buttonDiv">
                                    <QnectButton
                                        field="continue"
                                        onClick={() => {props.hideModal();}}
                                    />
                                </div>
                            </StyledModalDiv>
                        });
                        props.hideSpinner();
                    }
                }
                else {
                    props.hideSpinner();
                    setEmailErrorMessage(cfg('errorMessage.unknownError'));
                    setPasswordErrorMessage(cfg("errorMessage.unknownError"));
                }
            }, (error) => {
                if (error.response.status === 500 || error.response.status === 400 || error.response.status === 404) {
                    setEmailErrorMessage(cfg('errorMessage.serverError'));
                    setPasswordErrorMessage(cfg("errorMessage.serverError"));
                } else {
                    setEmailErrorMessage(error.response.statusText);
                    setPasswordErrorMessage(error.response.statusText);
                }
                props.hideSpinner();
            });
        }
    }

    const handleResend = () => {
        if (resendTimer === 0) {
            props.showSpinner();
            setOtpValue("");
            setOtpErrorMessage('');
            props.checkEmailIfRegistered(emailAddress, props.country).then((response) => {
                if (response.locked) {
                    setVerifyOpen(false);
                    setFailedOpen(true);
                }
                else if (response.isExisting === 'true') {
                    let otpToken = {
                        iv: response.iv,
                        token: response.token
                    }
                    props.setOtpToken(otpToken);
                }
                props.hideSpinner();
            });
            resetResendTimer();
        }
    }

    const handleVerifyOtp = () => {
        props.showSpinner();
        props.verifyOtpAndGetUserDetail(otpValue, props.user.email).then((response) => {
            if (response.locked) {
                setVerifyOpen(false);
                setFailedOpen(true);
            }
            else if (response.success) {
                props.setCpToken(response.token);
                props.setPortfolioToken(response.token);
                props.setTimerStarted(true);
                console.log("redirecting to portfolio");
                history.push('/portfolio');
            } else {
                setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
            }
            props.hideSpinner();
        }, (error) => {
            setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
            props.hideSpinner();
        })
    }

    const handleCloseForgotPasswordDialog = () => {
        setOpenForgotPasswordDialog(false);
        TagManager.dataLayer({
            dataLayer: {
                event: 'Icon-Click',
                eventCategory: 'Close'
            }
        })
    }

    const handleForgotPasswordSubmit = (email) => {
        props.showSpinner();
        props.sendResetPasswordLink(email)
            .then((response) => {
                console.log('handleForgotPasswordSubmit response', response)
                if (response.locked) {
                    props.showModal({
                        flat: true,
                        content: <StyledModalDiv>
                                    <div className="title">Reset Password is Locked</div>
                                    <div className="content">Please try again after 1 hour</div>
                                    <div className="buttonDiv">
                                        <QnectButton
                                            field="continue"
                                            onClick={() => props.hideModal()}
                                        />
                                    </div>
                                </StyledModalDiv>
                    });
                    setOpenForgotPasswordDialog(false);
                    props.hideSpinner();
                }
                else {
                    console.log("submitSuccessMessage");
                    TopNotice.show({
                        message: cfg("forgotPassword.submitSuccessMessage"),
                        duration: 3,
                    });
                    setOpenForgotPasswordDialog(false);
                    props.hideSpinner();
                }
            }, () => {
                TopNotice.show({
                    message: cfg("forgotPassword.submitSuccessMessage"),
                    duration: 3,
                });
                setOpenForgotPasswordDialog(false);
                props.hideSpinner();
            });
    }
    const hasError = !props.systemAvailable;
    const isPvtModeOn = props.isPvtModeOn;
    const[scheduledMaintenance, setScheduledMaintenance] = useState(null);

    useEffect(() => {
        props.getScheduledMaintenance().then(resp => {
            if (Object.keys(resp.data).length) {
                setScheduledMaintenance(resp.data);
            }
        });
    },[]);

    return (
        <>
            <div className={classes.container}>
                { (hasError || isPvtModeOn) && <SystemUnavailableBanner /> }
                { scheduledMaintenance && <ScheduledMaintenanceBanner value={scheduledMaintenance}/>}
                <div className={ classes.bg }>
                    <Hidden mdDown>
                        <div className={ classes.Cbg_img}/>
                    </Hidden>


                    <div className={classes.right_content}>
                        <Hidden smDown>
                            <div className={classes.icon_wrapper}>
                                <a onClick={() => {window.open('https://www.qbe.com/sg/about-qbe', '_blank');}}>
                                    <Logo/>
                                </a>
                            </div>
                        </Hidden>
                        <div className={classes.Mform} ref={ref}>
                            <div className={classes.subtitle} style={ props.lang === 'zh' ? {fontWeight: 'bold'} : {}}>
                                {cfg('login.title')}
                            </div>
                            <div className={classes.member_input}>
                                <div className={classes.login_tooltip}>
                                    <BalloonTip>You have to use your corporate email address as your Login ID.</BalloonTip>
                                </div>
                                <FieldWrapper>
                                    <QnectTextField
                                        field="loginEmailAddress"
                                        value={emailAddress}
                                        errorMessage={emailErrorMessage}
                                        onChange={e => {
                                            setEmailAddress(e.target.value);
                                            setEmailErrorMessage("");
                                        }}
                                        placeholder={ cfg('login.emailAddressPlaceHolder') }
                                        formId={formId}
                                    />
                                </FieldWrapper>
                                <FieldWrapper>
                                    <QnectTextField
                                        className="passwordField"
                                        field="loginPassword"
                                        type="password"
                                        value={password}
                                        formId={formId}
                                        errorMessage={passwordErrorMessage}
                                        onChange={e => {
                                            setPassword(e.target.value);
                                            setPasswordErrorMessage('');
                                        }}
                                    />
                                </FieldWrapper>
                                <FieldWrapper>
                                    <QnectButton
                                        field="continue"
                                        disabled={!emailAddress || hasError || isPvtModeOn}
                                        onClick={handleLogin}
                                    />
                                </FieldWrapper>
                                {isPvtModeOn && (
                                    <FieldWrapper>
                                        <div className="Small">
                                            <span className="ErrorText">
                                                {cfg('pvtModeOn.label')}
                                            </span>
                                        </div>
                                    </FieldWrapper>
                                )}
                            </div>



                            <div className={classes.forgotEmailPassword}>
                                <span className={classes.forgotPassword} onClick={() => {
                                    setOpenForgotPasswordDialog(true);
                                    setShowHelp(false);
                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'popup',
                                            popupPath: '/login',
                                            popupTitle: 'Forgot Password?'
                                        }
                                    });
                                }}>
                                        {cfg('login.forgotPassword')}
                                    </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <VerificationCodeDialog
                open={verifyOpen}
                maskedEmail={maskedEmail}
                onClose={() => setVerifyOpen(false)}
                onConfirm={handleVerifyOtp}
                onOther={() => {
                    setVerifyOpen(false);
                }}
                value={otpValue}
                setValue={setOtpValue}
                errorMessage={otpErrorMessage}
                setOtpErrorMessage={setOtpErrorMessage}
                handleResend={handleResend}
                resendTimer={resendTimer}
                cfg={cfg}
                lang={props.lang}
            />

            <ForgotPasswordDialog
                open={openForgotPasswordDialog}
                onClose={handleCloseForgotPasswordDialog}
                showHelp={() => {
                    setOpenForgotPasswordDialog(false);
                    setShowHelp(true);
                    TagManager.dataLayer({
                        dataLayer: {
                            event: 'popup',
                            popupPath: '/login',
                            popupTitle: 'Need Help? Contact Us'
                        }
                    });
                }}
                errorMessage={forgotPasswordErrorMessage}
                setErrorMessage={setForgotPasswordErrorMessage}
                onSubmit={handleForgotPasswordSubmit}
                cfg={cfg}
                lang={props.lang}
            />

            <TooManyFailedAttemptsDialog
                open={failedOpen}
                onClose={() => setFailedOpen(false)}
                cfg={cfg}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        lang: _getLang(state),
        noLogin: _isNoLogin(state),
        showOtpModal: _getShowOtpModal(state),
        user: _getUser(state),
        policy: _getPolicy(state),
        systemAvailable: _getSystemAvailable(state),
        isPvtModeOn: _getIsPvtModeOn(state)
    }
}

const mapDispatchToProps = {
    setLang: _setLang,
    checkEmailIfRegistered: _checkEmailIfRegistered,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    clearToken: _clearToken,
    storePolicy: _storePolicy,
    setOtpToken: _setOtpToken,
    setCpToken: _setCpToken,
    verifyOtpAndGetUserDetail: _verifyOtpAndGetUserDetail,
    storeUser: _storeUser,
    showModal: _showModal,
    hideModal: _hideModal,
    setShowOtpModal: _setShowOtpModal,
    generatePortfolioToken: _generatePortfolioToken,
    setPortfolioToken: _setPortfolioToken,
    getUserDetailsFromToken: _getUserDetailsFromToken,
    resetPolicy: _resetPolicy,
    resetUser: _resetUser,
    verifyUserCredentials: _verifyUserCredentials,
    sendResetPasswordLink: _sendResetPasswordLink,
    setTimerStarted: _setTimerStarted,
    getScheduledMaintenance: _getScheduledMaintenance
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
